// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"423":"34a0f17f","487":"2d539fec","488":"53b0618f"}[chunkId] + ".chunk.js";
};